import React from 'react';
import ValidateEmail from './ValidateEmail';

const AgentValidateEmail: React.FC = () => {
  return <ValidateEmail />;
};

export default AgentValidateEmail;
